import { render, staticRenderFns } from "./RecetteListeIngredients.vue?vue&type=template&id=7bc2b499&scoped=true&"
import script from "./RecetteListeIngredients.vue?vue&type=script&lang=js&"
export * from "./RecetteListeIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RecetteListeIngredients.vue?vue&type=style&index=0&id=7bc2b499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc2b499",
  null
  
)

export default component.exports